"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function () {
  var ownKeys = function (o) {
    ownKeys = Object.getOwnPropertyNames || function (o) {
      var ar = [];
      for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
      return ar;
    };
    return ownKeys(o);
  };
  return function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
    __setModuleDefault(result, mod);
    return result;
  };
}();
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TableEl = exports.CellContent = exports.SortButton = void 0;
const styled_components_1 = __importStar(require("styled-components"));
const StyledTable = styled_components_1.default.table`
  width: 100%;
  border: 0;
  font-family: 'Verdana';
  font-size: 12px;
  border: 1px solid #b9b9b9;
  border-spacing: 0;
`;
const Tr = styled_components_1.default.tr`
  ${props => props.hoverable && (0, styled_components_1.css)`
      &:hover {
        cursor: pointer;
      }
    `}
`;
const Th = styled_components_1.default.th`
  height: 40px;
  text-align: ${props => props.textAlign || 'left'};
  border: none;
  line-height: 2;

  & + & {
    border-left: 1px solid #e6e5e6;
  }
`;
const Td = styled_components_1.default.td`
  height: 40px;
  text-align: ${props => props.textAlign || 'left'};

  & + & {
    border-left: 1px dashed #1c1c1c;
  }
`;
const THead = styled_components_1.default.thead`
  ${Tr} {
    background-color: #a3a4a4;
  }
  ${Th} {
    color: #fff;
    font-weight: 700;
    padding: 0 8px;
  }
`;
const TBody = styled_components_1.default.tbody`
  ${Tr} {
    &:nth-child(odd) {
      background-color: #f2f2f3;
    }
    &:nth-child(even) {
      background-color: #e6e6e5;
    }
  }
  ${Td} {
    padding: 0 16px;
  }
`;
exports.SortButton = styled_components_1.default.button`
  &&& {
    background: 0;
    border: 0;
    height: 32px;
    width: 32px;
    position: relative;
    vertical-align: middle;
    cursor: pointer;
    margin-left: auto;

    &:before,
    &:after {
      content: '';
      width: 0;
      height: 0;
      border-style: solid;
      position: absolute;
      left: 50%;
    }

    &:before {
      border-width: 0 5px 8px 5px;
      border-color: transparent transparent #e6e5e6 transparent;
      transform: translate(-50%, 0);
      top: 5px;
    }

    &:after {
      border-width: 8px 5px 0 5px;
      border-color: #e6e5e6 transparent transparent transparent;
      transform: translate(-50%, 0);
      top: 21px;
    }

    ${props => props.sortDirection === 'asc' && (0, styled_components_1.css)`
        &:before {
          border-color: transparent transparent #fff transparent;
        }
      `}

    ${props => props.sortDirection === 'desc' && (0, styled_components_1.css)`
        &:after {
          border-color: #fff transparent transparent transparent;
        }
      `}
  }
`;
exports.CellContent = styled_components_1.default.div`
  display: flex;
  align-items: center;
`;
exports.TableEl = {
  StyledTable,
  THead,
  TBody,
  Tr,
  Th,
  Td
};